'use client';
import { jsx } from 'react/jsx-runtime';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(t, e) {
    if (null == t) return {};
    var r, o, a = _object_without_properties_loose(t, e);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        for(o = 0; o < n.length; o++)r = n[o], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (a[r] = t[r]);
    }
    return a;
}
function _object_without_properties_loose(t, e) {
    if (null == t) return {};
    var r, o, a = {}, n = Object.keys(t);
    for(o = 0; o < n.length; o++)r = n[o], e.indexOf(r) >= 0 || (a[r] = t[r]);
    return a;
}
const StandardTile = renderWithRef('StandardTile', null, (r, n)=>{
    useComponentStylesLoaded('StandardTile', SWAN_STYLE_KEY_MAP.standardTile);
    let { skin: d = 'standard', layout: l = 'vertical', imageWidth: i = 'standard' } = r, s = _object_without_properties(r, [
        "skin",
        "layout",
        "imageWidth"
    ]), c = new Set([
        'swan-standard-tile'
    ]);
    return 'standard' !== d && c.add(`swan-standard-tile-skin-${d}`), 'horizontal' === l && c.add('swan-standard-tile-horizontal'), 'full-bleed' === i && 'product' === d && c.add('swan-standard-tile-full-bleed'), jsx(RenderComp, {
        root: "div",
        forwardedRef: n,
        classNames: c,
        props: s,
        children: r.children
    });
});

export { StandardTile };
